import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { OperationInternalEvent } from './operation-internal-event'
import { operationInternalEventActions } from './operation-internal-event.actions'
import * as fromOperationInternalEvent from './operation-internal-event.reducer'
import { OperationInternalEventService } from './operation-internal-event.service'

@Injectable()
export class OperationInternalEventEffects extends ResourceEffects<OperationInternalEvent> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public operationInternalEventService: OperationInternalEventService
  ) {
    super(
      fromOperationInternalEvent.FEATURE_NAME,
      operationInternalEventService,
      operationInternalEventActions,
      actions$
    )
  }
}
